export default "__VITE_ASSET__BBVz6I8M__"